import { IColumn } from '@repo/ui';

const PROFESSIONAL_COLUMN_WIDTH = 280;
const DATE_COLUMN_WIDTH = 88;
const TOTAL_COLUMN_WIDTH = 96;

const formatDateColumnTitle = (date: string) => {
  const [, month, day] = date.split('-');

  return `${day}/${month}`;
};

export const makeNumberStudentsPerProfessionalInFieldColumns = (
  dates: string[],
): IColumn[] => [
  {
    title: 'Profissional',
    dataKey: 'professionalName',
    width: PROFESSIONAL_COLUMN_WIDTH,
    minWidth: PROFESSIONAL_COLUMN_WIDTH,
    flexGrow: 0,
    cellRenderer: ({ cellData }) => (
      <div className="students-per-professional-field-report-table__professional-cell">
        {cellData || '-'}
      </div>
    ),
  },
  ...dates.map((date) => ({
    title: formatDateColumnTitle(date),
    dataKey: date,
    width: DATE_COLUMN_WIDTH,
    minWidth: DATE_COLUMN_WIDTH,
    flexGrow: 0,
    cellRenderer: ({ cellData }) => (
      <div className="students-per-professional-field-report-table__metric-cell">
        {cellData ?? 0}
      </div>
    ),
  })),
  {
    title: 'Total',
    dataKey: 'total',
    width: TOTAL_COLUMN_WIDTH,
    minWidth: TOTAL_COLUMN_WIDTH,
    flexGrow: 0,
    cellRenderer: ({ cellData }) => (
      <div className="students-per-professional-field-report-table__metric-cell students-per-professional-field-report-table__metric-cell--total">
        {cellData ?? 0}
      </div>
    ),
  },
];
